var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isValidElement } from "react";
import convert from "react-from-dom";
const fetchSVG = (url) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(url);
    const contentType = response.headers.get("content-type");
    const [fileType] = (contentType || "").split(/ ?; ?/);
    if (response.status > 299) {
        throw new Error("Not found");
    }
    if (!["image/svg+xml", "text/plain"].some((d) => fileType.includes(d))) {
        throw new Error(`Content type isn't valid: ${fileType}`);
    }
    return response.text();
});
const updateSVGAttributes = (node, hash) => {
    const replaceableAttributes = ["id", "href", "xlink:href", "xlink:role", "xlink:arcrole"];
    const linkAttributes = ["href", "xlink:href"];
    const isDataValue = (name, value) => linkAttributes.includes(name) && (value ? !value.includes("#") : false);
    Array.from(node.children).map((d) => {
        if (d.attributes && d.attributes.length) {
            const attributes = Object.values(d.attributes).map((a) => {
                const attribute = a;
                const match = a.value.match(/url\((.*?)\)/);
                if (match && match[1]) {
                    attribute.value = a.value.replace(match[0], `url(${match[1]}__${hash})`);
                }
                return attribute;
            });
            replaceableAttributes.forEach((r) => {
                const attribute = attributes.find((a) => a.name === r);
                if (attribute && !isDataValue(r, attribute.value)) {
                    attribute.value = `${attribute.value}__${hash}`;
                }
            });
        }
        if (d.children.length) {
            return updateSVGAttributes(d, hash);
        }
        return d;
    });
    return node;
};
const getSVGElement = (content, hash) => {
    const node = convert(content, { nodeOnly: true });
    if (!node || !(node instanceof SVGSVGElement)) {
        throw new Error("Could not convert the src to a DOM Node");
    }
    const svg = updateSVGAttributes(node, hash);
    const element = convert(svg);
    if (!element || !isValidElement(element)) {
        throw new Error("Could not convert the src to a React element");
    }
    return element;
};
export const getLocalIconUrl = (iconName) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield import(`../svg/${iconName}.svg`)).default;
});
export const getErrorMessage = (error) => {
    if (error instanceof Error)
        return error.message;
    return String(error);
};
export const retrieveSVGElement = (url, hash) => __awaiter(void 0, void 0, void 0, function* () {
    const svgContent = yield fetchSVG(url);
    const svgElement = getSVGElement(svgContent, hash);
    return svgElement;
});
